import type { QueryKey } from '@tanstack/react-query';

/**
 * Maps a workflow `resourceTag` (emitted by the backend on
 * `workflow:state-changed`) to the TanStack Query keys that should be
 * invalidated so live dashboards + lists refresh (M2 §12.1). Kept in lock-step
 * with the backend RESOURCE_TAGS map in workflow-events.service.ts.
 */
export const WORKFLOW_QUERY_KEYS: Record<string, QueryKey[]> = {
  production: [
    ['dashboard'],
    ['operations', 'production'],
    ['executive-summary', 'gql'],
  ],
  operations: [['dashboard'], ['operations']],
  finance: [['dashboard'], ['finance']],
  safety: [['dashboard'], ['safety']],
  compliance: [['dashboard'], ['compliance']],
  'dashboard:production-overview': [['dashboard', 'production-overview']],
  'dashboard:development': [['dashboard', 'development']],
  'dashboard:disbursements': [['dashboard', 'payment-batches']],
  'dashboard:incidents': [['dashboard', 'safety']],
  'dashboard:compliance': [['dashboard', 'compliance']],
};

/** Resolve the set of query keys to invalidate for a list of resource tags. */
export function queryKeysForTags(tags: string[]): QueryKey[] {
  const keys: QueryKey[] = [];
  for (const tag of tags) {
    const mapped = WORKFLOW_QUERY_KEYS[tag];
    if (mapped) keys.push(...mapped);
  }
  return keys;
}
